(function(){
  // Mobile nav toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if(toggle && nav){
    toggle.addEventListener('click', function(){
      nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', nav.classList.contains('is-open'));
    });
  }

  // Product thumbnail swap
  document.querySelectorAll('[data-product-thumbs]').forEach(function(group){
    var main = group.parentElement.querySelector('[data-product-main]');
    group.querySelectorAll('img').forEach(function(t){
      t.addEventListener('click', function(){
        if(main){ main.src = t.dataset.full || t.src; }
        group.querySelectorAll('img').forEach(function(i){ i.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });
})();
